// Libellés d'affichage du statut d'un dossier, utilisés par le shell mobile v2. Le legacy garde sa
// propre copie sous forme de `switch` dans Opportunity/ShowComponent.vue (`generateTags`), à
// consolider ici le jour où la v2 devient le défaut.

const OPPORTUNITY_STATUS_LABELS: Record<string, string> = {
  created: 'Créé',
};

// Renvoie '' pour un statut inconnu ou absent, comme le legacy (`default: tag = null` → aucun
// badge). Ne JAMAIS retomber sur le statut brut : ce sont des slugs backend (`created`, …), les
// afficher tels quels expose du vocabulaire interne à l'utilisateur.
export function getOpportunityStatusLabel (status: string | null | undefined): string {
  if (!status) { return ''; }
  return OPPORTUNITY_STATUS_LABELS[status] ?? '';
}
